import styled from 'styled-components';

const FilterWrapper = styled.div`
  box-sizing: border-box;
  padding-top: ${({ isDesktop, noTopPadding }) => (isDesktop || noTopPadding ? '0' : '9px')};
  padding-left: ${({ isDesktop }) => (isDesktop ? '0' : '5px')};
  padding-right: 5px;
  padding-bottom: ${({ isDesktop }) => (!isDesktop ? '9px' : '5px')};
  display: flex;
  cursor: ${({ active }) => (active ? 'pointer' : null)};
  align-items: flex-start;

  ${({ isDesktop, active }) =>
    isDesktop && active
      ? `
        &:hover span {
          text-decoration: underline;
        }`
      : null};
`;

export default FilterWrapper;
